import {
  TCompanyMcpAccessMembersPage,
  TCompanyMcpAccessOverview,
} from '@commenda/types/src/company/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useCompanyMcpAccess(companyId: number | null) {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: TCompanyMcpAccessOverview;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? `company/${companyId}/mcp-access` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, isLoading, mutate };
}

export function useCompanyMcpAccessMembers(
  companyId: number | null,
  { search, skip, take }: { search: string; skip: number; take: number }
) {
  const query = new URLSearchParams({
    skip: String(skip),
    take: String(take),
    ...(search ? { search } : {}),
  }).toString();

  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: TCompanyMcpAccessMembersPage;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? `company/${companyId}/mcp-access/members?${query}` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, isLoading, mutate };
}
